import { BrowserModule,Title } from '@angular/platform-browser';
import { LocationStrategy, Location, PathLocationStrategy, HashLocationStrategy } from '@angular/common'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule, routes } from './app.routing.module';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import {ToastModule} from 'primeng/toast';
import { RDCServiceModule } from '../framework/services/services.module';
import { appSettings } from './app.settings';
import { InsertAuthTokenInterceptor } from './core/insert-auth-token-interceptor.service';
import { DropdownModule } from 'primeng/dropdown';
import { AppConfigService } from '../framework/services/app-config.service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ModalModule } from 'ngx-bootstrap/modal'
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PublicUserSignupComponent } from './public-user-signup/public-user-signup.component'
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {InputSwitchModule} from 'primeng/inputswitch';
import { FileUploadModule } from 'primeng';
import { LoginInternalComponent } from './login-internal/login-internal.component';
import { RouterModule } from '@angular/router';


import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  LogLevel,
  BrowserCacheLocation,
} from '@azure/msal-browser';
import {
  MsalGuard,
  MsalInterceptor,
  MsalBroadcastService,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalGuardConfiguration,
  MsalRedirectComponent
} from '@azure/msal-angular';

import {
  msalConfig,
  loginRequest,
  protectedResources,
} from './msal-authentication/auth-config';
import { environment } from 'src/environments/environment';
import { HomeModule } from './home/home.module';
import { ModalContentComponent } from './shared/modal-component/modal.component';
import { AddEngagementModule } from './add-engagement/add-engagement.module';
import { EditEngagementModule } from './edit-engagement/edit-engagement.module';


/**
 * Here we pass the configuration parameters to create an MSAL instance.
 * For more info, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/configuration.md
 */

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication(msalConfig);
}

/**
 * MSAL Angular will automatically retrieve tokens for resources
 * added to protectedResourceMap. For more info, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/initialization.md#get-tokens-for-web-api-calls
 */
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  /* const protectedResourceMap = [
    [environment.MsalConfig.T2_Api_url, [environment.MsalConfig.T2_API_Access]],
    [environment.MsalConfig.GraphUri + 'v1.0/me', ['user.read']],
    [environment.MsalConfig.GraphUri + 'v1.0/groups', ['user.read']],
  ]; */
  protectedResourceMap.set(
    protectedResources.armTenants.endpoint,
    protectedResources.armTenants.scopes
  );
  protectedResourceMap.set(
    protectedResources.graphMe.endpoint,
    protectedResources.graphMe.scopes
  );
  protectedResourceMap.set(
    protectedResources.groups.endpoint,
    protectedResources.groups.scopes
  );
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

/**
 * Set your default interaction type for MSALGuard here. If you have any
 * additional scopes you want the user to consent upon login, add them here as well.
 */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: loginRequest,
  };
}

@NgModule({
    declarations: [AppComponent, NavMenuComponent, PublicUserSignupComponent, LoginInternalComponent, ModalContentComponent],
    imports: [
        BrowserModule.withServerTransition({ appId: "ng-cli-universal" }),
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        DropdownModule,
        ToastModule,
        RDCServiceModule.forRoot(),
        NgxSpinnerModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        DialogModule,
        ButtonModule,
        FileUploadModule,
        InputSwitchModule,
        HomeModule,
        AddEngagementModule,
        EditEngagementModule,
        MsalModule.forRoot(new PublicClientApplication(msalConfig), null, null),
        //RouterModule.forRoot(routes, {useHash:false})
    ],
    providers: [
        //Location,
        // { provide: LocationStrategy, useClass: PathLocationStrategy },
        /* {
          provide: HTTP_INTERCEPTORS,
          useClass: MsalInterceptor,
          multi: true,
        }, */
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InsertAuthTokenInterceptor,
            multi: true
        },
        /*
        {
          provide: MSAL_INSTANCE,
          useFactory: MSALInstanceFactory,
        },
        {
          provide: MSAL_GUARD_CONFIG,
          useFactory: MSALGuardConfigFactory,
        },
        {
          provide: MSAL_INTERCEPTOR_CONFIG,
          useFactory: MSALInterceptorConfigFactory,
        }, */
        MsalService,
        /* MsalGuard, */
        MsalBroadcastService,
        AppConfigService,
        Title
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule {}
